import UtilsFormatter from '../utils/utils.Formatter';

/**
 * @category Utils
 * @description The UtilsData class
 * @alias UtilsData
 */
export default class UtilsData {
  static downloadPDF(pdf, filename) {
    //Fai in modo che il badge venga o scaricato o venga attivato il prompt del print
    //Preferirei prepare il download.
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(pdf);
    link.download = `${filename}.pdf`;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 7000);
  }

  static downloadExcel(excel, filename) {
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(excel);
    link.download = `${filename}.xlsx`;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 7000);
  }
}